
import { Component, Vue } from "vue-property-decorator";
import NameAndCedula from "@/components/person/NameAndCedula.vue";
import ValidationService from "@/services/ValidationService";
import User from "../models/User";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import { Getter } from "vuex-class";
import { AxiosResponse } from "axios";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import RequisitoBeneficio, {
  Requisito,
  ParametrosValidacionRequisitosBeneficio,
} from "@/models/RequisitoBeneficio";
import TipoRequisitoEnum from "@/enums/TipoRequisitoEnum";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import Swal from "sweetalert2";
import AfiliadoService from "@/services/AfiliadoService";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import Presolicitud from "@/models/Presolicitud";
import { formatFechaAfpSiembra } from "@/utils/HelperFunctions";
import ParamsGetSolicitud from "@/models/ParamsGetSolicitud";
import SolicitudBeneficio from "@/models/SolicitudBeneficio";
import ServiceResponseArchivos from "@/services/response-models/ServiceResponseArchivos";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import IngresoTardioService from "@/services/IngresoTardioService";

@Component({
  components: {
    NameAndCedula,
  },
})
export default class ResumenRedireccionador extends Vue {
  @Getter("user") user: User;
  public loading: boolean = false;
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public ingresoTardioService = new IngresoTardioService();
  public currentPresolicitud: Presolicitud = null;
  public currentSolicitud: SolicitudBeneficio = null;
  public documentosCurrentPresolicitud: DocumentoPresolicitud[] = [];
  public tipoDocumentos: Requisito[] = [];
  public nombresTiposDocs: string[] = [];

  get montoFormatted() {
    return this.currentSolicitud && this.currentSolicitud.montoResumen
      ? this.currentSolicitud.montoResumen.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        })
      : "";
  }

  public mounted(): void {
    var packageParameter = this.$route.query.packageId
      ? this.$route.query.packageId
      : this.$route.query.package;
    if (packageParameter) {
      this.showLoadingAlert("Cargando...");
      this.loading = true;
      let path: string = null;
      let query: any = {};
      const packageId: string = String(packageParameter);
      const packageStatus: string = String(this.$route.query.status);
      this.afiliadoService
        .getPresolicitud(
          new ParametrosObtencionPresolicitud(null, null, null, packageId)
        )
        .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
          if (
            response.data.solicitudes &&
            response.data.solicitudes.length > 0
          ) {
            // The first one must be the record we are looking for
            this.currentPresolicitud = response.data.solicitudes[0];

            switch (Number(this.currentPresolicitud.tipoBeneficio)) {
              case TipoBeneficioEnum.IngresoTardio:
                path = "/resumen-solicitud-it";
                query = { packageId: packageId };
                break;
              case TipoBeneficioEnum.Cesantia:
                path = "/resumen-solicitud-cesantia";
                query = { packageId: packageId };
                break;
            }
            this.$router.push({
              path: path,
              query: query,
            });
          }
        })
        .catch((e) => {
          console.error(e);
          Swal.close();
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.navigateToSolicitudes();
    }
  }

  public navigateToSolicitudes(): void {
    this.$router.push("/solicitudes-beneficiario");
  }

  public formatDate(dateString: string) {
    return formatFechaAfpSiembra(dateString);
  }

  public showErrorAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "error",
      allowOutsideClick: true,
      showConfirmButton: true,
      confirmButtonText: "Ok",
    });
  }
  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }
}
